module.exports = __webpack_public_path__ + "img/img23.884dab5b.png";